import { CommonContext } from '@repo-level/core-front';
import { FC, useContext } from 'react';

import { NotAllowedCountry } from 'components/internal/NotAllowedCountry';
import { useFranceLocale } from 'hooks/franceLocale';

export const Restricted: FC = ({ children }) => {
  const { isRestricted } = useFranceLocale();
  const { currentIp } = useContext(CommonContext);

  if (currentIp && isRestricted) {
    return <NotAllowedCountry countryCode={currentIp?.countryCode} />;
  }

  return <>{children}</>;
};
